import '../assets/App.css';
import dwarfWriting from '../assets/dwarf-writing.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteNames } from '../components/AppRouter';
import axiosInstance from '../services/axios';

function RegisterPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axiosInstance.post('/api/register', {
                email: email,
                password: password,
                firstName: firstName
            });

            if (response.status === 201) {
                navigate(RouteNames.login, {
                    state: {
                        registrationSuccess: true,
                        message: 'Votre compte a été créé avec succès ! Vous pouvez maintenant vous connecter.'
                    }
                });
            }
        } catch (err) {
            if (err.response && err.response.status === 400) {
                setError('Les informations fournies sont invalides. Veuillez vérifier vos données.');
            } else if (err.response && err.response.status === 409) {
                setError('Un compte avec cet email existe déjà.');
            } else {
                setError('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="hero-body">
            <div className="container has-text-centered">
                <div className="columns is-vcentered">
                    <div className="column is-5">
                        <figure className="image is-4by3">
                            <img src={dwarfWriting} alt="" />
                        </figure>
                    </div>
                    <div className="column is-6 is-offset-1 box">
                        <h1 className="title is-2">
                            Inscription
                        </h1>
                        <form onSubmit={handleSubmit}>
                            <div className="field">
                                <div className="control">
                                    <input
                                        className="input is-large"
                                        type="text"
                                        placeholder="Prénom"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            <div className="field">
                                <div className="control">
                                    <input
                                        className="input is-large"
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            <div className="field">
                                <div className="control">
                                    <input
                                        className="input is-large"
                                        type="password"
                                        placeholder="Mot de passe"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        disabled={loading}
                                    />
                                </div>
                            </div>
                            {error && (
                                <div className="notification is-danger is-light">
                                    {error}
                                </div>
                            )}
                            <div className="field">
                                <button
                                    className={`button is-block is-dark is-large is-fullwidth ${loading ? 'is-loading' : ''}`}
                                    type="submit"
                                    disabled={loading}
                                >
                                    S'inscrire
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegisterPage;
